import { Box } from '@deity/falcon-ui';
import type React from 'react';

type dropDownItemProps = {
  value: number | string;
  iconName?: string;
  displayName?: string;
  handleChange?: (val, iconName?, displayName?) => void;
};
export const DropDownItem: React.FC<dropDownItemProps> = ({ value, children, iconName, displayName, handleChange }) => (
  <Box
    width="full"
    p="xs"
    border="regular"
    borderColor="transparent"
    css={{
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#f3f5f7'
      }
    }}
    onClick={() => handleChange && handleChange(value, iconName, displayName)}
  >
    {children}
  </Box>
);
